import { render } from "./breadcrumbs.vue?vue&type=template&id=0b758829&scoped=true&ts=true"
import script from "./breadcrumbs.vue?vue&type=script&lang=ts"
export * from "./breadcrumbs.vue?vue&type=script&lang=ts"

import "./breadcrumbs.vue?vue&type=style&index=0&id=0b758829&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b758829"]])

export default __exports__